import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { AnalyticsService } from 'src/services/analytics.service';
import { ApiService } from 'src/services/api.service';

@Component({
  selector: 'app-giphy-modal',
  templateUrl: './giphy-modal.component.html',
  styleUrls: ['./giphy-modal.component.scss'],
})
export class GiphyModalComponent implements OnInit {
  @ViewChild('searchInput') searchInput;
  searchValue: string;
  gifs: any[];

  constructor(
    private apiService: ApiService,
    private modalCtrl: ModalController,
    private analyticsService: AnalyticsService,
  ) {}

  ngOnInit() {
    this.getGifs();

    setTimeout(() => {
      this.searchInput.setFocus();
    }, 500);
  }

  async getGifs() {
    const request = this.apiService.get(`/giphy`, {
      search: this.searchValue || '',
    });

    request.subscribe((result: any) => {
      if (result) {
        this.gifs = result.data;
      }
    });
  }

  selectGif(gif: string, title: string) {
    this.analyticsService.trackEvent('Giphy Modal', 'Select gif');

    this.modalCtrl.dismiss({
      url: gif,
      title,
    });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
